import { ExternalAction } from 'components-machine';
import { TrueTheme } from 'schema/poll';
import { sendInfo } from 'src/sentry';
import { inIframe } from './location';

let isFirstEvent = true;

const shouldLogIframeEvent = () => {
  // опрос t-partners
  return window.location.href.includes('clv3xpkgb00235uuj84xdbtri');
};

export function notifyParent(content: IframeEvent) {
  if (!inIframe({ ignoreForce: true })) {
    return;
  }

  if (isFirstEvent && shouldLogIframeEvent()) {
    sendInfo(`iframe event: ${JSON.stringify(content)}`);
    isFirstEvent = false;
  }

  // TODO: должны ли мы добавить опцию для ограничения встраивания определённых опросов?
  // Сейчас мы не ограничиваем где может быть встроен опрос, поэтому должны разрешать любому домену получать сообщения
  // eslint-disable-next-line @microsoft/sdl/no-postmessage-star-origin
  window.parent.postMessage(JSON.stringify(content), '*');
}

export type IframeEvent =
  | { type: 'survey_iframe_init'; theme: TrueTheme['data'] }
  | { type: 'survey_iframe_focused' }
  | { type: 'survey_iframe_width'; width: number | null }
  | { type: 'survey_iframe_height'; height: number }
  // свойство status нужно только для обратной совместимости
  | { type: 'survey_iframe_done'; status: 'done'; collected_score: number }
  // свойство status нужно только для обратной совместимости
  | { type: 'survey_iframe_done_requests'; status: 'done' }
  | { type: 'survey_iframe_screen_changed' }
  // свойство status нужен только для обратной совместимости
  | { type: 'survey_iframe_requests_close'; status: 'done'; finished: boolean; eventId: string }
  | { type: 'survey_iframe_requests_close_unsafe'; finished: boolean; eventId: string }
  | { type: 'survey_iframe_requests_scroll'; top: number }
  | (
      | {
          type: 'survey_iframe_readystatechange';
          state: 'ready';
        }
      | {
          type: 'survey_iframe_readystatechange';
          state: 'paused';
          reason: 'TRACKING_ERROR';
        }
      | {
          type: 'survey_iframe_readystatechange';
          state: 'cancelled';
          reason: 'UNKNOWN_ERROR' | 'TRACKING_ERROR' | 'INCORRECT_CONFIGURATION' | 'WITHDRAWN' | 'COMPLETED';
        }
    )
  // свойство state нужно только для обратной совместимости
  | {
      type: 'survey_iframe_result';
      result: Extract<ExternalAction, { type: 'overall' }>['overallResult'];
      state: 'done';
    }
  | {
      type: 'survey_iframe_change_answer';
      questionId: string;
      answeredIds: string[];
      answersOrder: number[] | undefined;
    };
